import React, { useEffect, useState } from "react";
import QuestPreview from "../../components/QuestPreview/QuestPreview";
import Footer from "../../components/Footer/Footer";

const Quests = () => {
  const [quests, setQuests] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("date");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/questsManifest.json")
      .then((res) => res.json())
      .then((data) => {
        setQuests(data.sort((a, b) => b.date.localeCompare(a.date)));
      });
  }, []);

  // Latest quests, sorted by date descending
  const latestQuests = [...quests]
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 2);

  // Filter, search, and sort all quests
  let filteredQuests = quests;

  if (search) {
    filteredQuests = filteredQuests.filter(
      (quest) =>
        quest.title.toLowerCase().includes(search.toLowerCase()) ||
        quest.excerpt.toLowerCase().includes(search.toLowerCase()) ||
        (quest.tags && quest.tags.some(tag => tag.toLowerCase().includes(search.toLowerCase())))
    );
  }

  if (statusFilter) {
    filteredQuests = filteredQuests.filter((quest) => quest.status === statusFilter);
  }

  // Sort
  if (sort === "name") {
    filteredQuests = [...filteredQuests].sort((a, b) =>
      a.title.localeCompare(b.title)
    );
  } else if (sort === "date") {
    filteredQuests = [...filteredQuests].sort((a, b) =>
      b.date.localeCompare(a.date)
    );
  }

  return (
    <>
      <main style={{ minHeight: "60vh", padding: "2rem 0 0 0" }}>
        <h1 style={{ textAlign: "center", color: "var(--text)" }}>Quests</h1>
        <section style={{ width: "100%", maxWidth: 900, margin: "0 auto" }}>
          <QuestPreview quests={latestQuests} title="Latest Quests" />
        </section>
        <section style={{ maxWidth: 900, margin: "2rem auto 0 auto" }}>
          <div className="quest-search-bar">
            <input
              type="text"
              placeholder="Search quests..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ flex: 1, minWidth: 180 }}
            />
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="date">Sort by Date</option>
              <option value="name">Sort by Name</option>
            </select>
            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
              <option value="">All Status</option>
              <option value="completed">Completed</option>
              <option value="in-progress">In Progress</option>
              <option value="planned">Planned</option>
            </select>
          </div>
          <QuestPreview quests={filteredQuests} title="All Quests" />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Quests;
